import { render, staticRenderFns } from "./configFilterTable.vue?vue&type=template&id=56856134&scoped=true&"
import script from "./configFilterTable.js?vue&type=script&lang=js&"
export * from "./configFilterTable.js?vue&type=script&lang=js&"
import style0 from "./configFilterTable.scss?vue&type=style&index=0&id=56856134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56856134",
  null
  
)

export default component.exports